/* eslint-disable react/no-unescaped-entities */
import React from "react";

function EmptyBody() {
  return (
    <>
      The sun hung low on the horizon, casting a warm, golden glow over the
      tranquil beach. Waves gently lapped at the shore, and seagulls soared
      overhead, their calls mingling with the distant laughter of children
      playing in the sand. A couple strolled hand in hand along the water's
      edge, leaving footprints that would soon be erased by the tide. It was a
      serene moment, a snapshot of summer's beauty that would linger in their
      memories for years to come.
      <br></br>
      <br></br>
      As the day slowly transitioned into evening, the colors of the sky began
      to shift, painting a breathtaking canvas of pinks, oranges, and purples.
      Families gathered around bonfires, roasting marshmallows and sharing
      stories, their faces illuminated by the dancing flames. A lone figure sat
      at the water's edge, lost in thought, watching as the stars blinked into
      existence one by one in the deepening night. The rhythmic sound of a
      guitar strumming and soft singing could be heard from a group of friends
      huddled around a beachside campfire, creating a soundtrack to this idyllic
      coastal scene. It was a reminder that sometimes, the simplest moments by
      the sea could be the most profound, weaving memories that would forever be
      cherished.
    </>
  );
}

export default EmptyBody;
